module.exports = __webpack_public_path__ + "static/media/home.17fb1613.jpg";